<template>
  <div class="img-wrapper" :style="getStyle()">
    <img src="@/assets/template/question_btn.png" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      required: false,
      default: '32px',
    },
    height: {
      type: String,
      required: false,
      default: '32px',
    },
    rounded: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    getStyle() {
      return {
        width: this.width,
        height: this.height,
        'border-radius': this.rounded ? '50%' : '4px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.img-wrapper {
  min-width: 28px;
  min-height: 28px;
  padding: 4px;
  border: solid 2px rgb(20, 9, 17);
  background: white;
  img {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/buttons/QuestionButton.vue